import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TruncatePipe } from '../../../../shared/pipes/truncate/truncate.pipe';

@Component({
  selector: 'now-wbsuche-lib-detail-kachel',
  templateUrl: './detail-kachel.component.html',
  styleUrls: ['./detail-kachel.component.scss'],
  imports: [NgClass, TruncatePipe]
})
export class DetailKachelComponent {
  @Input({ required: true })
  public title!: string;

  @Input({ required: true })
  public icon!: string;

  @Input({ required: true })
  public id!: string;

  /** @deprecated Wird nicht mehr ausgewertet und bleibt nur zur Kompabilität bestehen. */
  @Input({ required: true })
  public collapseButtonText!: string;

  /** Zeigt den Button "mehr Inhalte" und blendet den Inhalt eingeklappt aus. */
  @Input()
  public ausklappbar = false;

  /** Gekürzter Fließtext, der eingeklappt vor dem Button steht. */
  @Input()
  public anreisser = '';

  @Output()
  collapsedChanged = new EventEmitter<boolean>();

  @Input()
  public collapsed = true;

  public umschalten(): void {
    this.collapsed = !this.collapsed;
    this.collapsedChanged.emit(this.collapsed);
  }
}
